interface IScrollToElementProp extends ScrollIntoViewOptions {
  offset?: string;
}

export function scrollToElement(elementOrSelector?: string | Element | null, options?: IScrollToElementProp) {
  let el: Element | null = null;

  if (!elementOrSelector) {
    return;
  }

  if (typeof elementOrSelector === 'string') {
    el = document.querySelector(elementOrSelector) || null;
  } else {
    el = elementOrSelector;
  }

  if (!el || !(el instanceof HTMLElement)) {
    // Не элемент, поэтому не можем с ним взаимодействовать
    return;
  }

  const opt: IScrollToElementProp = {
    behavior: 'smooth',
    ...options,
  };

  if (options?.offset) {
    el.style.scrollMarginTop = `${options?.offset}`;
  }

  el.scrollIntoView(opt);
}
